import React from 'react'

import {
  Route,
  useRouteMatch
} from 'react-router-dom'

export const SPORTSBOOK_PATH_PATTERN = '/:sportName?/:categoryName?/:tournamentName?/:eventName?'

export function SportsbookRouter (props) {
  const {
    path = SPORTSBOOK_PATH_PATTERN,
    children
  } = props

  const {
    path: rootPath
  } = useRouteMatch()

  const routePath = rootPath + path

  return (
    <Route
      exact={false}
      strict={false}
      rootPath={rootPath}
      path={routePath}
    >
      {children}
    </Route>
  )
}
